module.exports = __webpack_public_path__ + "img/logo-black.1f85cb1d.png";